import axios from '../config/axiosConfig'

export const getCoberturas = () => {
  return axios.get('/coberturas').then(response => response.data.coberturas).catch(err => console.log(err))
}

export const getSucursales = () => {
  return axios.get('/sucursales').then(response => response.data.sucursales).catch(err => console.log(err))
}

export const getEspecialidades = () => {
  return axios.get('/especialidades').then(response => response.data.especialidades).catch(err => console.log(err))
}

export const getPrestaciones = (especialidad) => {
  const especialidadQuery = `?especialidad=${especialidad}`
  return axios.get(`/prestaciones${especialidadQuery}`).then(response => response.data.prestaciones).catch(err => console.log(err))
}

export const getProfesionales = (especialidad) => {
  const especialidadQuery = `?especialidad=${especialidad}`
  return axios.get(`/profesionales${especialidadQuery}`).then(response => response.data.profesionales).catch(err => console.log(err))
}

export const getTurnosCalendario = (params) => {
  const { obraSocial, plan, sucursal, especialidad, prestacion, profesional } = params
  const baseURL = '/turnoscalendario'
  const obraSocialQuery = `?obraSocial=${obraSocial}`
  const planQuery = `&plan=${plan}`
  const sucursalQuery = `&sucursal=${sucursal}`
  const especialidadQuery = `&especialidad=${especialidad}`
  const prestacionQuery = `&prestacion=${prestacion}`
  const profesionalQuery = `&profesional=${profesional}`
  return axios
    .get(`${baseURL}${obraSocialQuery}${planQuery}${sucursalQuery}${especialidadQuery}${prestacionQuery}${profesionalQuery}`)
    .then(response => response.data.calendario)
    .catch(err => console.log(err))
}

export const getTurnosLibres = (params, date) => {
  const { obraSocial, plan, sucursal, especialidad, prestacion, profesional } = params
  const baseURL = '/turnoslibres'
  const dateQuery = `?fecha=${date.replace(/-/g, '')}`
  const obraSocialQuery = `&obraSocial=${obraSocial}`
  const planQuery = `&plan=${plan}`
  const sucursalQuery = `&sucursal=${sucursal}`
  const especialidadQuery = `&especialidad=${especialidad}`
  const prestacionQuery = `&prestacion=${prestacion}`
  const profesionalQuery = `&profesional=${profesional}`
  return axios
    .get(`${baseURL}${dateQuery}${obraSocialQuery}${planQuery}${sucursalQuery}${especialidadQuery}${prestacionQuery}${profesionalQuery}`)
    .then(response => response.data.turnos)
    .catch(err => console.log(err))
}

export const getTurnosPendientes = (pacienteId) => {
  const baseURL = '/turnospendientes'
  const pacienteIdQuery = `?pacienteId=${pacienteId}`
  return axios
    .get(`${baseURL}${pacienteIdQuery}`)
    .then(response => response.data.turnos)
    .catch(err => console.log(err))
}

export const verificarTurno = (patient, turno) => {
  const baseURL = '/verificarturno'
  const pacienteIdQuery = `?pacienteId=${patient.pacienteId}`
  const obraSocialQuery = `&obraSocial=${patient.obraSocial}`
  const planQuery = `&plan=${patient.plan}`
  const prestacionQuery = `&prestacion=${patient.prestacion}`
  const turnoQuery = `&turno=${turno}`
  return axios
    .get(`${baseURL}${pacienteIdQuery}${obraSocialQuery}${planQuery}${prestacionQuery}${turnoQuery}`)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export const reservarTurno = (turno) => {
  const baseURL = '/reservarturno'
  return axios
    .post(`${baseURL}`, { ...turno })
    .then(response => response.data)
    .catch(err => console.log(err))
}

export const anularTurno = (patient) => {
  const baseURL = '/anularturno'
  return axios
    .post(`${baseURL}`, { ...patient })
    .then(response => response.data)
    .catch(err => console.log(err))
}

export const enviarMail = (pacienteId) => {
  const baseURL = '/enviarmail'
  const pacienteIdQuery = `?pacienteId=${pacienteId}`
  return axios
    .get(`${baseURL}${pacienteIdQuery}`)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export const confirmarTurno = (patient) => {
  const baseURL = '/confirmarturno'
  return axios
    .post(`${baseURL}`, { ...patient })
    .then(response => response.data)
    .catch(err => console.log(err))
}
